import React, { useEffect, useState } from "react";
import { submitDemoRequest } from "../../../resources/contact-request/mutation";
import { Link } from "react-router-dom";
import { Box, Button, Stack, Typography } from "knack-ui";
import { motion, Variants } from "framer-motion";
import create from "zustand";

import HeroImg from "../LandingPage/hero-image.webp";
import PlatformMockup from "../LandingPage/dummy-video.webp";
import MashoorahLogo from "../LandingPage/Logo/mashoorah-logo-white.svg";
import requestDemoPopupImg from "../LandingPage/request-demo-popup.webp";
import Soc2Logo from "../LandingPage/Logo/soc2-aws.png";
import valuesVisual from "../LandingPage/values-banner.webp";
import unlockVisual from "../LandingPage/unlock-potential-banner.webp";
import imgMentorship from "../LandingPage/affordable-pricing.webp";
import imgAnalytics from "../LandingPage/analytics-darker.jpg";
import imgIntelligent from "../LandingPage/icons/intelligent-matching-icon.svg";
import imgPerformance from "../LandingPage/icons/performance-tracking-icon.svg";
import imgAdvanced from "../LandingPage/icons/advanced-anaytics-icon.svg";
import bgImg from "../LandingPage/testimonials-banner.webp";
import mentorImg from "../LandingPage/dummy-testimonial.webp";
import coachImg from "../LandingPage/expand-your-reach-banner.webp";
import img1 from "../LandingPage/blog-1.webp";
import img2 from "../LandingPage/blog-2.webp";
import img3 from "../LandingPage/blog-3.webp";
import leftBanner from "../LandingPage/coach-and-mentor-side-banner.webp";
import rightTop from "../LandingPage/join-as-a-coach.png";
import rightBottom from "../LandingPage/become-a-mentor.webp";
import expert1Image from "../LandingPage/experts/khalid-alkhudairi.webp";
import linkedinDefault from "../LandingPage/icons/linkedin-icon-default-state.svg";
import linkedinHover from "../LandingPage/icons/linkedin-icon-hover-state.svg";
import emailDefault from "../LandingPage/icons/email-icon-default-state.svg";
import emailHover from "../LandingPage/icons/email-icon-hover-state.svg";
import ctaBackground from "../LandingPage/footer-banner.webp";

const colorOrange = "#ed7f3d";
const colorLightPink = "#fceae0";
const colorSecondary = "#f7cbb9";
const colorLightPurple = "#f2e8f3";
const colorPurple = "#e3cfe6";
const colorBlack = "#141414";

interface LandingStoreProps {
  selectedFeature: number | null;
  setSelectedFeature: (id: number | null) => void;
}
export const useLandingStore = create<LandingStoreProps>((set) => ({
  selectedFeature: null,
  setSelectedFeature: (id) => set(() => ({ selectedFeature: id }))
}));

const fadeInUp: Variants = {
  hidden: { y: 16, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.45 } }
};

const Hero: React.FC<{ onOpenModal: () => void }> = ({ onOpenModal }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box
      as={motion.section}
      variants={fadeInUp}
      initial="hidden"
      animate="visible"
      className="relative w-full min-h-screen flex flex-col"
      style={{
        backgroundImage: `url(${HeroImg})`,
        borderRadius: 0,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      {isOpen && (
        <div className="fixed top-0 left-0 w-screen h-screen bg-black flex items-center justify-center z-50">
          <div className="absolute top-0 right-0 mx-auto px-6 py-6  z-10 ">
            <button onClick={() => setIsOpen(false)} className="text-white font-semibold text-lg">
              X
            </button>
          </div>
          <div className="absolute top-0 left-0 mx-auto px-6 py-6 z-10">
            <Link to="/" className="flex items-center">
              <img src={MashoorahLogo} alt="Mashoorah Logo" className="h-12 md:h-16 w-auto" />
            </Link>

            <div className="s md:flex items-center gap-10 w-full justify-between text-lg">
              {" "}
              <ul className="flex flex-col gap-8 font-medium text-white mt-12">
                {["About", "Login", "Request a demo"].map((item) => (
                  <li key={item}>
                    {item === "About" ? (
                      <button
                        onClick={() => {
                          setIsOpen(false);
                          document.getElementById("about-section")?.scrollIntoView({
                            behavior: "smooth"
                          });
                        }}
                        className="text-white font-semibold text-lg"
                      >
                        {item}
                      </button>
                    ) : item === "Request a demo" ? (
                      <button
                        onClick={() => {
                          setIsOpen(false);
                          onOpenModal();
                        }}
                        className="text-white font-semibold text-lg"
                      >
                        {item}
                      </button>
                    ) : (
                      <Link to="/login" className="text-white font-semibold text-lg">
                        {item}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8 py-6 flex items-center justify-between z-10 w-full">
        <Link to="/" className="flex items-center">
          <img src={MashoorahLogo} alt="Mashoorah Logo" className="h-12 md:h-16 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-10 w-full justify-between text-lg">
          {" "}
          <ul className="flex gap-12 font-medium mr-auto ml-20 text-white">
            {["About"].map((item) => (
              <li key={item}>
                {item === "About" ? (
                  <button
                    onClick={() => {
                      document.getElementById("about-section")?.scrollIntoView({
                        behavior: "smooth"
                      });
                    }}
                    className="text-white font-semibold text-lg"
                  >
                    {item}
                  </button>
                ) : (
                  <Link to="#" className="text-white font-semibold text-lg">
                    {item}
                  </Link>
                )}
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-6">
            <Link to="/auth/login" className="font-semibold text-white text-lg">
              Login
            </Link>
            <Button
              onClick={onOpenModal}
              variant="large"
              style={{
                backgroundColor: colorOrange,
                color: "white",
                borderRadius: "9999px",
                fontWeight: 600,
                transition: "background-color 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = colorBlack;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = colorOrange;
              }}
            >
              Request a demo
            </Button>
          </div>
        </div>

        <div className="md:hidden">
          <button aria-label="Open menu" className="p-2 rounded-md text-white text-3xl" onClick={() => setIsOpen(true)}>
            ☰
          </button>
        </div>
      </div>

      <div className="relative max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8 w-full grid grid-cols-1 md:grid-cols-2 gap-12 z-0 mt-20">
        <div className="flex flex-col justify-center">
          <Stack direction="column" gap={6} alignItems="flex-start" className="text-white">
            <Typography
              variant="h2"
              as="h1"
              className="text-4xl md:text-6xl leading-tight"
              style={{ fontFamily: "PlayfairDisplay", fontStyle: "normal", fontWeight: 300 }}
            >
              Shape the future of your workforce.
            </Typography>
            <Typography variant="body1" className="text-base font-medium md:text-xl text-white/90 max-w-lg">
              Scalable coaching and mentorship programs designed to develop talent, enhance performance, and deliver measurable business
              impact.
            </Typography>

            <div className="mt-8 flex gap-4">
              <Button
                onClick={onOpenModal}
                variant="large"
                style={{
                  backgroundColor: colorOrange,
                  color: "white",
                  borderRadius: "9999px",
                  transition: "background-color 0.3s ease",
                  fontWeight: 600
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colorBlack;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = colorOrange;
                }}
              >
                Get started
              </Button>
            </div>
          </Stack>
        </div>

        <div className="w-80 md:w-96 h-[46rem] md:h-[50rem] rounded-5rem shadow-lg overflow-hidden mx-auto border border-white">
          <img src={PlatformMockup} alt="Platform mockup" className="w-full h-full object-cover rounded-5rem" />
        </div>
      </div>
    </Box>
  );
};

// const LogosSection: React.FC = () => {
//   const logos = [MashoorahLogoBlack, MashoorahLogoBlack, MashoorahLogoBlack, MashoorahLogoBlack, MashoorahLogoBlack];

//   return (
//     <Box className="w-full py-16" style={{ backgroundColor: colorLightPurple }}>
//       <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto flex justify-between items-center gap-4 px-6 md:px-8">
//         {logos.map((logo, idx) => (
//           <img key={idx} src={logo} alt={`logo-${idx}`} className="h-10 md:h-12 object-contain" />
//         ))}
//       </div>
//     </Box>
//   );
// };

const BlackCTA: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full py-16 px-6 md:px-0" style={{ backgroundColor: colorLightPink }}>
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8 relative">
        <div
          className="flex items-start justify-between gap-4 cursor-pointer select-none pb-5"
          style={{ borderBottom: `1px solid ${colorOrange}` }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <h2 id="about-section" className="text-black text-2xl md:text-3xl lg:text-4xl font-bold text-left">
            More than a platform. A partner in growth.
          </h2>
          <button aria-label={isOpen ? "Close" : "Open"} className="mt-1 p-1">
            {isOpen ? (
              <svg
                className="md:w-6 md:h-6 w-16"
                fill="none"
                stroke={isOpen ? "black" : colorOrange}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
              </svg>
            ) : (
              <svg className="md:w-6 md:h-6 w-16" fill="none" stroke={colorOrange} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            )}
          </button>
        </div>
        {isOpen && (
          <p className="mt-6 font-medium text-left leading-relaxed text-base md:text-lg transition-all duration-300 ease-in-out text-black">
            Mashoorah is a coaching and mentorship platform that helps organizations design and scale structured development programs,
            connect employees with mentors, and track progress with measurable insights. By combining personalized guidance with data-driven
            analytics, we enable organizations to unlock potential, close skill gaps, and drive sustainable growth.
          </p>
        )}
      </div>
    </div>
  );
};

const FeatureSection: React.FC = () => {
  const features = [
    {
      title: "Enable\norganizational\ngrowth",
      text: "Help companies launch, manage, and scale internal or external development programs aligned with business goals."
    },
    {
      title: "Assess\nand develop\ntalent",
      text: "Provide tools and insights to evaluate employee capabilities, identify skill gaps, and guide professional growth."
    },
    {
      title: "Bridge local\nand global\nstandards",
      text: "Combine Saudi-rooted cultural understanding with global best practices in coaching and talent development."
    },
    {
      title: "Support\ninclusive\ndevelopment",
      text: "Serve leaders, managers, employees, and HR/L&D teams across government and private sectors, fostering sustainable talent growth."
    }
  ];

  return (
    <div
      className="w-full text-white py-16 md:py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${unlockVisual})`
      }}
    >
      <div className="bg-black/60 w-full py-16 md:py-20">
        <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="flex flex-col justify-center h-full min-h-[400px]">
            <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold leading-tight text-center lg:text-left">
              Unlock potential.
              <br />
              Drive performance.
            </h2>
          </div>

          <div className="grid grid-cols-2 border-gray-700/50">
            {features.map((feature, idx) => {
              const isLastRow = idx >= features.length - 2;
              return (
                <div
                  key={idx}
                  className={`flex flex-col p-6 h-full bg-black/40 
            ${idx % 2 === 0 ? "border-r" : ""} 
            ${!isLastRow ? "border-b" : ""}`}
                >
                  <h3
                    className="text-white whitespace-pre-line text-lg md:text-xl mb-2 lg:mb-3 leading-snug"
                    style={{
                      fontFamily: "PlayfairDisplay",
                      fontWeight: 300
                    }}
                  >
                    {feature.title}
                  </h3>
                  <p className="text-gray-200 text-sm lg:text-base">{feature.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const tooltips = {
  Empowerment: "We inspire and enable growth at every level.",
  Impact: "We focus on initiatives that deliver meaningful, measurable results.",
  Professionalism: "We maintain credibility, structure, and reliability in all we do.",
  Measurability: "We track progress and outcomes to ensure tangible value."
};

const WhiteCTA: React.FC = () => {
  const [hovered, setHovered] = useState<string | null>(null);

  const wordsTop = ["Empowerment", "Impact"];
  const wordsBottom = ["Professionalism", "Measurability"];

  const renderWords = (words: string[]) =>
    words.map((word) => (
      <span
        key={word}
        className="relative inline-block"
        style={{ width: window.innerWidth >= 768 ? "fit-content" : "100%" }}
        onMouseEnter={() => setHovered(word)}
        onMouseLeave={() => setHovered(null)}
      >
        <span
          className="transition-colors duration-300 px-1"
          style={{
            color: hovered === word ? colorSecondary : colorBlack,
            fontSize: window.innerWidth >= 768 ? "2.25rem" : "2rem",
            fontWeight: 600
          }}
        >
          {word}.
        </span>

        {hovered === word && (
          <span
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white px-2 py-1 rounded-none whitespace-nowrap shadow-md"
            style={{
              backgroundColor: colorBlack,
              zIndex: 50,
              fontSize: window.innerWidth >= 768 ? ".9rem" : ".65rem"
            }}
          >
            {tooltips[word as keyof typeof tooltips]}
          </span>
        )}
      </span>
    ));

  return (
    <div
      className="w-full py-20 px-6 md:px-0 bg-cover bg-center bg-no-repeat bg-fixed"
      style={{
        backgroundImage: `url(${valuesVisual})`,
        backgroundPosition: "center center"
      }}
    >
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8">
        <div className="flex gap-2 flex-wrap">{renderWords(wordsTop)}</div>
        <div className="flex gap-2 flex-wrap mt-2">{renderWords(wordsBottom)}</div>
      </div>
    </div>
  );
};

const ImageCTASection: React.FC = () => {
  const ctas = [
    {
      title: "Powerful mentorship\nmade affordable.",
      buttonText: "Explore plans",
      img: imgMentorship
    },
    {
      title: "Analytics that\ndrive real growth.",
      buttonText: "Learn more",
      img: imgAnalytics
    }
  ];

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2">
      {ctas.map((cta, idx) => (
        <div
          key={idx}
          className="relative aspect-square flex items-center justify-center text-left"
          style={{
            backgroundImage: `url(${cta.img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "550px"
          }}
        >
          <div className="absolute inset-0 bg-black/40" />

          <div className="relative z-10 max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8">
            <h2
              className="text-white whitespace-pre-line text-2xl md:text-3xl lg:text-4xl font-bold mb-3 leading-tight tracking-tight"
              style={{ lineHeight: "1.1" }}
            >
              {cta.title}
            </h2>
            <div className="mt-8 flex gap-4">
              {/* <Button
                as={Link}
                to="/request-demo"
                variant="large"
                style={{
                  backgroundColor: colorOrange,
                  color: "white",
                  borderRadius: "9999px",
                  transition: "background-color 0.3s ease",
                  fontWeight: 600
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colorBlack;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = colorOrange;
                }}
              >
                {cta.buttonText}
              </Button> */}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const CardsSection: React.FC = () => {
  const cards = [
    {
      title: "Intelligent\nmatching",
      text: "Offer tailored coaching experiences that address individual needs while maintaining consistency and structure across the organization.",
      icon: imgIntelligent
    },
    {
      title: "Performance\ntracking",
      text: "Monitor progress with clarity, from individual milestones to organizational impact.",
      icon: imgPerformance
    },
    {
      title: "Advanced\nanalytics",
      text: "Gain deep insights into skill gaps, development outcomes, and measurable ROI.",
      icon: imgAdvanced
    }
  ];

  return (
    <div className="w-full py-20 lg:py-24" style={{ backgroundColor: colorLightPink }}>
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8">
        <h2 className="text-black text-left text-2xl md:text-3xl lg:text-4xl font-bold mb-16 leading-tight" style={{ fontWeight: 500 }}>
          Coaching and mentorship. Reinvented.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card, idx) => (
            <div key={idx} className="flex flex-col border border-black overflow-hidden shadow-lg">
              <div
                className="p-6 md:p-8"
                style={{
                  backgroundColor: colorBlack,
                  fontFamily: "PlayfairDisplay",
                  fontWeight: 300
                }}
              >
                <h3 className="text-white text-xl md:text-2xl leading-snug whitespace-pre-line">{card.title}</h3>
              </div>
              <div className="p-6 md:p-8 flex flex-col items-start gap-4">
                <img src={card.icon} alt={`${card.title} icon`} className="w-20 h-20 md:w-24 md:h-24 object-contain" />
                <p className="text-black text-sm md:text-base leading-relaxed">{card.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      text: "What I really like about Mashoorah is how it combines structured programs with personal mentorship. It’s not just about connecting people — it actually shows us the impact coaching is making.",
      author: "Jane Doe",
      role: "Senior Manager - Maven Insights",
      imgUrl: mentorImg
    },
    {
      text: "The mix of analytics and mentoring makes it a really unique experience.",
      author: "John Doe",
      role: "Team Lead",
      imgUrl: mentorImg
    }
  ];

  const [index, setIndex] = useState(0);

  const prevTestimonial = () => setIndex((i) => (i - 1 + testimonials.length) % testimonials.length);
  const nextTestimonial = () => setIndex((i) => (i + 1) % testimonials.length);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % testimonials.length), 10000);
    return () => clearInterval(t);
  }, [testimonials.length]);

  const current = testimonials[index];

  return (
    <div
      className="w-full py-12 md:py-16 text-white bg-cover bg-center relative"
      style={{
        backgroundImage: `url(${bgImg})`,
        height: "400px"
      }}
    >
      <div className="absolute inset-0 bg-black/50" />
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8 relative flex flex-col justify-center gap-8 h-full">
        <div className="flex items-center justify-between text-3xl font-bold text-orange-500">
          <Button
            onClick={prevTestimonial}
            className="bg-transparent border-0 shadow-none transition-colors duration-300"
            style={{ backgroundColor: "transparent", color: colorOrange }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
            onMouseLeave={(e) => (e.currentTarget.style.color = colorOrange)}
          >
            &lt;
          </Button>

          <p className="flex-1 text-base sm:text-lg md:text-xl font-normal leading-relaxed text-center max-w-full break-words px-2 sm:px-4">
            "{current.text}"
          </p>

          <Button
            onClick={nextTestimonial}
            className="bg-transparent border-0 shadow-none transition-colors duration-300"
            style={{ backgroundColor: "transparent", color: colorOrange }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
            onMouseLeave={(e) => (e.currentTarget.style.color = colorOrange)}
          >
            &gt;
          </Button>
        </div>

        <div className="flex items-center justify-between mt-6 flex-shrink-0">
          <div className="flex flex-col gap-1 text-left">
            <p className="text-xl md:text-2xl font-bold text-white">{current.author}</p>
            <p className="text-base text-white/90">{current.role}</p>
          </div>

          <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden border border-white shadow-xl flex-shrink-0">
            <img src={current.imgUrl} alt={current.author} className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
};

const CoachCTA: React.FC = () => {
  return (
    <div
      className="w-full relative bg-cover bg-no-repeat py-20 md:py-28 lg:py-32 bg-fixed"
      style={{
        backgroundImage: `url(${coachImg})`,
        backgroundPosition: "center top 70%",
        backgroundSize: "cover",
        minHeight: "450px"
      }}
    >
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
      <div className="relative z-10 max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8 text-left flex flex-col justify-center h-full">
        <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-6 md:mb-8 leading-tight">
          Expand your reach as a coach or mentor.
        </h2>

        <p className="text-white text-base md:text-lg lg:text-xl mb-8 md:mb-10 leading-relaxed max-w-3xl">
          Mashoorah offers subscription plans for external professionals, enabling you to guide, connect, and create impact beyond
          organizational boundaries.
        </p>

        {/* <div className="mt-8 flex gap-3">
          <Button
            as={Link}
            to="/request-demo"
            variant="large"
            style={{
              backgroundColor: colorOrange,
              color: "white",
              borderRadius: "9999px",
              transition: "background-color 0.3s ease",
              fontWeight: 600
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = colorBlack;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = colorOrange;
            }}
          >
            Explore plans
          </Button>
        </div> */}
      </div>
    </div>
  );
};

const LatestCoaching: React.FC = () => {
  const items = [
    { image: img1, title: "How mentorship programs boost employee engagement and performance." },
    { image: img2, title: "What leading organizations do to scale coaching and drive measurable growth." },
    { image: img3, title: "How data-driven coaching unlocks skills and closes talent gaps." }
  ];

  const [index, setIndex] = useState(0);
  const visibleCount = 3;

  const prev = () => setIndex((i) => (i - 1 + items.length) % items.length);
  const next = () => setIndex((i) => (i + 1) % items.length);
  const visibleItems = Array.from({ length: visibleCount }, (_, offset) => items[(index + offset) % items.length]);

  return (
    <div className="w-full py-20 md:py-32" style={{ backgroundColor: colorLightPurple }}>
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8 text-left">
        <h2 className="text-gray-900 text-2xl md:text-3xl lg:text-4xl font-bold mb-16">The latest in coaching, mentorship and growth.</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-10 transition-all duration-500">
          {visibleItems.map((item, i) => (
            <div key={i} className="overflow-hidden bg-transparent text-left flex flex-col justify-between h-[300px]">
              <img src={item.image} alt={item.title} className="w-full h-auto object-cover mb-4 " />
              <div className="px-1 flex flex-col justify-between flex-grow">
                <h3 className="text-gray-900 text-lg md:text-xl font-bold mb-3 leading-snug min-h-[60px]">{item.title}</h3>

                <p className="text-gray-900 font-semibold text-sm underline cursor-pointer hover:opacity-80">Discover more</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-6">
          <Button
            onClick={prev}
            className="p-1 bg-transparent border-0 shadow-none"
            style={{ backgroundColor: "transparent" }}
            onMouseEnter={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", colorOrange)}
            onMouseLeave={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", "black")}
          >
            {" "}
            <svg className="w-6 h-6" fill="none" stroke="black" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {" "}
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>{" "}
            </svg>{" "}
          </Button>{" "}
          <Button
            onClick={next}
            className="p-1 bg-transparent border-0 shadow-none"
            style={{ backgroundColor: "transparent" }}
            onMouseEnter={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", colorOrange)}
            onMouseLeave={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", "black")}
          >
            {" "}
            <svg className="w-6 h-6" fill="none" stroke="black" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {" "}
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>{" "}
            </svg>{" "}
          </Button>
        </div>
      </div>
    </div>
  );
};

const CoachMentorSection: React.FC = () => {
  return (
    <Box className="w-full h-screen 2xl:h-[900px] rounded-none-important overflow-hidden">
      <div className="w-full h-full grid grid-cols-1 md:grid-cols-2 grid-rows-1 md:grid-rows-1 gap-0">
        <div className="w-full h-full">
          <img src={leftBanner} alt="Coach Banner" className="w-full h-full object-cover" />
        </div>

        <div className="w-full h-full grid grid-rows-2 gap-0">
          <div className="w-full h-full relative">
            <img src={rightTop} alt="Right Top" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/40 flex flex-col items-start justify-center p-6">
              <h3 className="text-white text-lg md:text-2xl font-bold mb-4 leading-snug">
                Empower growth <br />
                through structured <br />
                coaching.
              </h3>
              <Button
                as={Link}
                to="/login"
                variant="large"
                style={{
                  backgroundColor: colorOrange,
                  color: "white",
                  borderRadius: "9999px",
                  transition: "background-color 0.3s ease",
                  fontWeight: 600
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colorBlack;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = colorOrange;
                }}
              >
                Join as a coach
              </Button>
            </div>
          </div>

          <div className="w-full h-full relative">
            <img src={rightBottom} alt="Right Bottom" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/40 flex flex-col items-start justify-center p-6">
              <h3 className="text-white text-lg md:text-2xl font-bold mb-4 leading-snug">
                Inspire the next <br />
                generation through <br />
                mentorship.
              </h3>
              <Button
                as={Link}
                to="/login"
                variant="large"
                style={{
                  backgroundColor: colorOrange,
                  color: "white",
                  borderRadius: "9999px",
                  transition: "background-color 0.3s ease",
                  fontWeight: 600
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colorBlack;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = colorOrange;
                }}
              >
                Become a mentor
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

const DataProtection: React.FC = () => {
  return (
    <Box as="section" className="py-20" style={{ backgroundColor: colorLightPink }}>
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 text-left">
        <Typography
          variant="h2"
          as="h2"
          className="text-2xl md:text-3xl lg:text-4xl font-bold"
          style={{
            fontWeight: 600,
            fontSize: "2.25rem",
            lineHeight: "2rem",
            marginBottom: "1.5rem"
          }}
        >
          Protecting your data, every step of the way.
        </Typography>

        <Typography variant="body1" className="mt-4 text-lg leading-relaxed max-w-3xl">
          At Mashoorah, your privacy and security come first. Built on AWS SOC 2 Type II, with end-to-end encryption, role-based access &
          MFA, and SSO via Azure AD, we follow best practices and ensure transparency and security — so you can focus on growth with
          confidence.
        </Typography>
        <div className="mt-10 flex gap-12 flex-wrap">
          <img src={Soc2Logo} alt="Security Logo 2" className="h-20 md:h-24 object-contain" />
        </div>
      </div>
    </Box>
  );
};

const SocialIcon: React.FC<{
  to: string;
  defaultIcon: string;
  hoverIcon: string;
  alt: string;
}> = ({ to, defaultIcon, hoverIcon, alt }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="transition-all duration-300 transform hover:scale-110 inline-block"
    >
      <img src={isHovered ? hoverIcon : defaultIcon} alt={alt} className="w-8 h-8" />
    </a>
  );
};

export const ExpertsSection: React.FC = () => {
  const experts = [
    {
      name: "Khalid Alkhudairi",
      role: "coach",
      image: expert1Image,
      description: `Khalid is a strategic advisor with over 16 years of experience guiding organizations 
      in growth, transformation, and restructuring across the public and private sectors.`,
      social: { linkedin: "https://www.linkedin.com/in/khalidalkhudairi/", email: "mailto:khalid.alkhudairi@maveninsights.com" }
    }
  ];

  const [index, setIndex] = useState(0);
  const CARDS_PER_VIEW_DESKTOP = 3;
  const CARDS_PER_VIEW_MOBILE = 1;

  const getCardsPerView = () => (window.innerWidth >= 768 ? CARDS_PER_VIEW_DESKTOP : CARDS_PER_VIEW_MOBILE);

  const prev = () => {
    const cardsPerView = getCardsPerView();
    setIndex((i) => (i > 0 ? i - 1 : experts.length - cardsPerView));
  };

  const next = () => {
    const cardsPerView = getCardsPerView();
    setIndex((i) => (i < experts.length - cardsPerView ? i + 1 : 0));
  };

  const ExpertCard = ({ expert }: { expert: typeof experts[0] }) => {
    const roleColor = expert.role === "mentor" ? colorPurple : colorOrange;
    return (
      <div className="relative flex-none w-full md:w-1/3 group cursor-pointer">
        <div className="relative">
          <img src={expert.image} alt={expert.name} className="w-full object-cover" />
          <div className="absolute bottom-0 left-0 right-0 bg-black p-4 text-white flex justify-start gap-2 group-hover:opacity-0 transition-opacity duration-300">
            <span className="font-semibold">{expert.name}</span>
            <span style={{ color: roleColor }}>/ {expert.role}</span>
          </div>
          <div className="absolute inset-0 bg-black text-white p-6 flex flex-col justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center">
            <div className="flex justify-center items-center gap-2">
              <span className="font-semibold">{expert.name}</span>
              <span style={{ color: roleColor }}>/ {expert.role}</span>
            </div>
            <p className="mt-4 text-sm text-left">{expert.description}</p>
            <div className="flex gap-4 mt-4 justify-start w-full">
              {expert.social.linkedin && (
                <SocialIcon to={expert.social.linkedin} defaultIcon={linkedinDefault} hoverIcon={linkedinHover} alt="LinkedIn" />
              )}
              {/* {expert.social.email && <SocialIcon to={expert.social.email} defaultIcon={emailDefault} hoverIcon={emailHover} alt="Email" />} */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const translateXValue = `-${index * (100 / getCardsPerView())}%`;

  return (
    <Box as="section" className="py-20" style={{ backgroundColor: colorLightPurple }}>
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 text-left">
        <Typography
          variant="h2"
          as="h2"
          className="text-2xl md:text-3xl lg:text-4xl font-bold"
          style={{
            fontWeight: 600,
            fontSize: "2.25rem",
            lineHeight: "2rem",
            marginBottom: "1.5rem"
          }}
        >
          Meet the experts behind the impact.
        </Typography>

        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-500 gap-4 justify-center"
            style={{ transform: `translateX(${translateXValue})` }}
          >
            {experts.map((expert, i) => (
              <ExpertCard key={i} expert={expert} />
            ))}
          </div>
        </div>

        {/* <div className="flex justify-center gap-6 mt-12">
          <Button
            onClick={prev}
            className="p-1 bg-transparent border-0 shadow-none"
            style={{ backgroundColor: "transparent" }}
            onMouseEnter={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", colorOrange)}
            onMouseLeave={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", "black")}
          >
            <svg className="w-6 h-6" fill="none" stroke="black" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
          </Button>

          <Button
            onClick={next}
            className="p-1 bg-transparent border-0 shadow-none"
            style={{ backgroundColor: "transparent" }}
            onMouseEnter={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", colorOrange)}
            onMouseLeave={(e) => e.currentTarget.querySelector("svg")!.setAttribute("stroke", "black")}
          >
            <svg className="w-6 h-6" fill="none" stroke="black" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
            </svg>
          </Button>
        </div> */}
      </div>
    </Box>
  );
};

const CTA: React.FC<{ onOpenModal: () => void }> = ({ onOpenModal }) => {
  return (
    <Box
      className="w-full bg-cover bg-center relative bg-fixed rounded-none-important"
      style={{
        backgroundImage: `url(${ctaBackground})`,
        height: "400px"
      }}
    >
      <div className="relative max-w-6xl 2xl:max-w-screen-2xl mx-auto h-full px-6 md:px-8 flex flex-col justify-center items-start">
        <Typography variant="h4" as="h2" className="text-white text-2xl md:text-3xl lg:text-4xl font-bold" style={{ color: "white" }}>
          Start building the workforce of tomorrow, today.
        </Typography>

        <div className="mt-6">
          <Button
            onClick={onOpenModal}
            variant="large"
            style={{
              backgroundColor: colorOrange,
              color: "white",
              borderRadius: "9999px",
              transition: "background-color 0.3s ease",
              fontWeight: 600
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = colorBlack;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = colorOrange;
            }}
          >
            Request a demo
          </Button>
        </div>
      </div>
    </Box>
  );
};

const Footer: React.FC = () => {
  const [linkedinSrc, setLinkedinSrc] = React.useState<string>(linkedinDefault);
  const [emailSrc, setEmailSrc] = React.useState<string>(emailDefault);

  const linkClasses = "text-white hover:text-gray-300 transition-colors duration-200 block mt-3 text-base";

  return (
    <footer className="bg-black text-gray-300 py-16 px-4 sm:px-12 lg:px-24">
      <div className="max-w-6xl 2xl:max-w-screen-2xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 lg:grid-cols-12 gap-y-12 gap-x-8">
          <div className="grid md:col-span-2 lg:col-span-5 gap-y-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-x-12 gap-y-8 lg:text-sm text-xs">
              <img src={MashoorahLogo} alt="Mashoorah Logo" className="h-16" />
              <div className="whitespace-nowrap">
                <p className="font-bold text-white mb-2">Riyadh, KSA</p>
                <p>4288, Anas Bin Malik,</p>
                <p>6745, Al Maleqa Dist.</p>
                <p></p>
                <p>Riyadh, KSA</p>
                <p className="mt-2">T +966 11 257 1940</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-x-12 gap-y-8 lg:text-sm text-xs">
              <div className="whitespace-nowrap">
                <p className="font-bold text-white mb-2">Abu Dhabi, UAE</p>
                <p>Block B Offices</p>
                <p>Musaffah, M40, 91</p>
                <p>Abu Dhabi, UAE</p>
                <p className="mt-2">T +971 5 259 91055</p>
              </div>
              <div className="whitespace-nowrap">
                <p className="font-bold text-white mb-2">Dubai, UAE</p>
                <p>Jumeirah Lakes Towers (Y)</p>
                <p>Swiss Tower 3402, Floor 34</p>
                <p>Dubai, UAE</p>
                <p className="mt-2">T +971 4 561 3707</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-1 lg:col-span-3 lg:ml-12">
            <div className="space-y-6">
              {/* <a href="#" className={linkClasses}>
                Solutions
              </a> */}
              {/* <a href="#" className={linkClasses}>
                About
              </a> */}
              {/* <a href="#" className={linkClasses}>
                Blog
              </a> */}
            </div>
          </div>

          <div className="md:col-span-2 lg:col-span-4 flex flex-col items-start md:items-end justify-start">
            <div className="flex space-x-3 mb-6">
              <a
                href="https://www.linkedin.com/company/mashoorah"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
                onMouseEnter={() => setLinkedinSrc(linkedinHover)}
                onMouseLeave={() => setLinkedinSrc(linkedinDefault)}
              >
                <img src={linkedinSrc} alt="LinkedIn" className="w-10 h-10" />
              </a>
              <a
                href="mailto:info@mashoorah.co"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
                onMouseEnter={() => setEmailSrc(emailHover)}
                onMouseLeave={() => setEmailSrc(emailDefault)}
              >
                <img src={emailSrc} alt="Email" className="w-10 h-10" />
              </a>
            </div>
            <div className="mt-auto pt-6 text-xs text-gray-500" style={{ color: colorPurple }}>
              © 2025 Mashoorah. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const ContactModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const [selectedSize, setSelectedSize] = useState<string | null>(null);
  const [fullName, setFullName] = useState('');
  const [businessEmail, setBusinessEmail] = useState('');
  const [question, setQuestion] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!fullName || !businessEmail) return;
    setSubmitting(true);
    try {
      await submitDemoRequest({
        name: fullName,
        email: businessEmail,
        message: question || undefined,
        companySize: selectedSize,
      });
      setSubmitted(true);
    } catch (err) {
      console.error('Contact request failed:', err);
    } finally {
      setSubmitting(false);
    }
  };
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0" onClick={onClose} />

      <div
        className="relative z-10 w-full mx-4 bg-white rounded-5rem shadow-xl p-12 bg-cover bg-center flex flex-col justify-center items-center"
        style={{
          maxWidth: "1200px",
          height: "90vh",
          backgroundImage: `url(${requestDemoPopupImg})`
        }}
      >
        <button onClick={onClose} className="absolute top-8 right-10 text-white text-4xl">
          ×
        </button>
        <div className="w-full max-w-lg ">
          {submitted ? (
            <div className="flex flex-col items-center justify-center text-center">
              <div className="text-5xl mb-4">✅</div>
              <h2 className="text-2xl md:text-4xl font-bold mb-2 text-white">Thank you!</h2>
              <p className="text-white mb-8">We've received your request. Our team will contact you soon.</p>
              <button
                onClick={onClose}
                className="px-6 py-2 rounded-full"
                style={{ backgroundColor: colorOrange, color: 'white', fontWeight: 600 }}
              >
                Close
              </button>
            </div>
          ) : (
            <>
              <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-12 text-white">Request a Demo</h2>

              <form className="flex flex-col" onSubmit={handleSubmit}>
            <label className="text-white" htmlFor="full-name">
              Full Name
            </label>
            <input
              type="text"
              id="full-name"
              className="w-full p-2 mb-4 border rounded-lg bg-transparent focus:outline-none text-white"
              style={{
                border: "1px solid #ed7f3d"
              }}
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
            <label className="text-white" htmlFor="business-email">
              Business Email
            </label>
            <input
              type="email"
              id="business-email"
              className="w-full p-2 mb-4 border rounded-lg bg-transparent focus:outline-none text-white"
              style={{
                border: "1px solid #ed7f3d"
              }}
              value={businessEmail}
              onChange={(e) => setBusinessEmail(e.target.value)}
            />
            <label className="text-white" htmlFor="company-size">
              Company Size
            </label>
            <div
              className=""
              style={{
                display: "flex",
                gap: "1rem",
                borderRadius: "1rem",
                backgroundColor: "transparent"
              }}
            >
              {["< 50", "50 - 500", "500 - 1000", "> 1000"].map((item) => {
                const isSelected = selectedSize === item;
                return (
                  <div
                    className="text-xs md:text-md"
                    key={item}
                    onClick={() => setSelectedSize(item)}
                    style={{
                      flex: 1,
                      border: "1px solid #ed7f3d",
                      borderRadius: "0.5rem",
                      padding: "0.5rem",
                      textAlign: "center",
                      cursor: "pointer",
                      color: isSelected ? "#ed7f3d" : "white",
                      backgroundColor: isSelected ? "white" : "transparent",
                      fontWeight: isSelected ? 600 : 500,
                      transition: "0.2s"
                    }}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
            <label className="text-white mt-4" htmlFor="question">
              How would you like to utilize the platform?
            </label>
            <textarea
              id="question"
              rows={3}
              className="w-full p-2 mb-4 border rounded-lg bg-transparent focus:outline-none text-white"
              style={{ border: "1px solid #ed7f3d" }}
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />

                <button
                  type="submit"
                  className="py-3 font-medium"
                  style={{
                    backgroundColor: colorOrange,
                    width: "fit-content",
                    color: "white",
                    padding: "0.7rem 2rem",
                    alignSelf: "end",
                    borderRadius: "9999px",
                    transition: "background-color 0.3s ease",
                    fontWeight: 600
                  }}
                >
                  {submitting ? 'Submitting...' : 'Send'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const LandingPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="landing-page w-full overflow-x-hidden bg-transparent">
      <main className="m-0 p-0">
        <Hero onOpenModal={() => setIsModalOpen(true)} />
        {/* <LogosSection /> */}
        <BlackCTA />
        <FeatureSection />
        <WhiteCTA />
        <ImageCTASection />
        <CardsSection />
        {/* <Testimonials /> */}
        <CoachCTA />
        {/* <LatestCoaching /> */}
        <CoachMentorSection />
        <DataProtection />
        <ExpertsSection />
        <CTA onOpenModal={() => setIsModalOpen(true)} />
        <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
